import type { FC, SVGProps } from 'react';

import { ReactComponent as FacebookLogo } from 'src/assets/icons/social/fb.svg';
import { ReactComponent as InstagramLogo } from 'src/assets/icons/social/instagram.svg';
import { ReactComponent as TiktokLogo } from 'src/assets/icons/social/tiktok.svg';
import { ReactComponent as WhatsappLogo } from 'src/assets/icons/social/whatsapp.svg';
import { ReactComponent as YoutubeLogo } from 'src/assets/icons/social/youtube.svg';

import { IS_HUTTO_CEMETERY } from 'src/constants/app-common';
import { LOCALES } from 'src/constants/locale';

export const SOCIAL_LINKS_LIST = [
  {
    label: 'TikTok',
    logo: TiktokLogo,
    url: window.TIKTOK_PAGE_URL,
  },
  {
    label: 'WhatsApp',
    logo: WhatsappLogo,
    url: window.WHATSAPP_PAGE_URL,
  },
  {
    label: 'Instagram',
    logo: InstagramLogo,
    url: window.INSTAGRAM_PAGE_URL,
  },
  {
    label: LOCALES.FACEBOOK,
    logo: FacebookLogo,
    url: window.FACEBOOK_PAGE_URL,
  },
  {
    label: 'Youtube',
    logo: YoutubeLogo,
    url: window.YOUTUBE_PAGE_URL,
  },
];

export const SOCIAL_LINKS = (
  IS_HUTTO_CEMETERY
    ? SOCIAL_LINKS_LIST.sort(({ label }) => (label === LOCALES.FACEBOOK ? -1 : 0))
    : SOCIAL_LINKS_LIST
).filter((item) => item.url) as { label: string; logo: FC<SVGProps<SVGSVGElement>>; url: string }[];
